/**
 * bulletin-records/types — 레코드 페이지(/catalog-entry/bulletin/:vendor/:doc_no/records)의 상태.
 *
 * 한 편의 assemble 결과(assembled/<번호>.jsonl)를 줄 단위로 본다. VOCABULARY "제품 등록" 레코드 페이지.
 */
import { E_ASSEMBLED_RECORD_TYPES } from '../../api/client';
import type * as api from '../../api/client';

/** type 탭 — all + 여섯 type */
export const E_RECORD_TYPE_FILTERS = ['all', ...E_ASSEMBLED_RECORD_TYPES] as const;
export type  ERecordTypeFilter     = typeof E_RECORD_TYPE_FILTERS[number];

export interface BulletinRecordsData {
  key:        api.BulletinDocKey;         // 주소창의 (vendor, doc_no)
  doc:        api.BulletinDocView | null; // 그 편. 불러오기 전엔 null
  records:    api.AssembledRecord[];      // 파일 순서 그대로
  typeFilter: ERecordTypeFilter;          // 기본 all
  loading:    boolean;
  error:      string;                     // '' 이면 오류 없음
}
